// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.emailverification.RentalManagerUserEmailVerificationV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ContactEmailVerificationSendVerificationCodeRequestDto,
  ContactEmailVerificationValidateVerificationCodeRequestDto,
  RentalManagerContactEmailVerificationCodeValidationDto,
  RentalManagerContactEmailVerificationEmailVerificationDto,
  UserEmailVerificationSendSecurityTokenRequestDto,
  UserEmailVerificationSendSecurityTokenV2ResponseWebDto,
  UserEmailVerificationVerifySecurityTokenRequestDto,
  UserEmailVerificationVerifySecurityTokenV2ResponseWebDto,
} from '../..';

export const RentalManagerUserEmailVerificationV2WebApiHandler_sendSecurityToken_Path =
  '/api/web/v2/users/emailVerification/sendSecurityToken';

/**
 * Email the email verification link to the user
 */
export const RentalManagerUserEmailVerificationV2WebApiHandler_sendSecurityToken = (
  postData: UserEmailVerificationSendSecurityTokenRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserEmailVerificationSendSecurityTokenRequestDto,
    UserEmailVerificationSendSecurityTokenV2ResponseWebDto
  >(
    {
      endpoint: RentalManagerUserEmailVerificationV2WebApiHandler_sendSecurityToken_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserEmailVerificationV2WebApiHandler_sendVerificationCode_Path =
  '/api/web/v2/users/emailVerification/sendVerificationCode';

/**
 * Email the contact email verification code to the user
 */
export const RentalManagerUserEmailVerificationV2WebApiHandler_sendVerificationCode = (
  postData: ContactEmailVerificationSendVerificationCodeRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    ContactEmailVerificationSendVerificationCodeRequestDto,
    RentalManagerContactEmailVerificationEmailVerificationDto
  >(
    {
      endpoint: RentalManagerUserEmailVerificationV2WebApiHandler_sendVerificationCode_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserEmailVerificationV2WebApiHandler_validateVerificationCode_Path =
  '/api/web/v2/users/emailVerification/validateVerificationCode';

/**
 * Validate code for contact email verification
 */
export const RentalManagerUserEmailVerificationV2WebApiHandler_validateVerificationCode = (
  postData: ContactEmailVerificationValidateVerificationCodeRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    ContactEmailVerificationValidateVerificationCodeRequestDto,
    RentalManagerContactEmailVerificationCodeValidationDto
  >(
    {
      endpoint: RentalManagerUserEmailVerificationV2WebApiHandler_validateVerificationCode_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserEmailVerificationV2WebApiHandler_verifySecurityToken_Path =
  '/api/web/v2/users/emailVerification/verifySecurityToken';

/**
 * Verify securityToken from email verification
 */
export const RentalManagerUserEmailVerificationV2WebApiHandler_verifySecurityToken = (
  postData: UserEmailVerificationVerifySecurityTokenRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserEmailVerificationVerifySecurityTokenRequestDto,
    UserEmailVerificationVerifySecurityTokenV2ResponseWebDto
  >(
    {
      endpoint: RentalManagerUserEmailVerificationV2WebApiHandler_verifySecurityToken_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
